import { mapToObjectDDL } from "../../common/mapper";
import { v4 as uuidv4 } from "uuid";
import * as R from "ramda";

export const getDataDetail = (data) => {
  return (
    data?.map((item) => {
      return {
        id: item.id,
        coaDetailId: item.coaDetailId,
        transactionType: item.transactionType,
        category: mapToObjectDDL(item.category, item.category),
        subGroup: mapToObjectDDL(item.subGroup?.value, item.subGroup?.key),
        group: mapToObjectDDL(item.group?.value, item.group?.key),
        status: item.status,
        saved: true,
      };
    }) || []
  );
};

export const getValueItemFromArrayDDL = (object, key) => {
  if (
    object?.[key] === undefined ||
    R.isNil(object[key]) ||
    R.isEmpty(object[key])
  ) {
    return [];
  }

  return Array.isArray(object[key].value)
    ? object[key].value.map((item) => {
        return { kode: item.kode, qty: Number(item.jumlah) };
      })
    : [];
};

export const validateDataItem = (obj) => {
  const fieldsToValidate = ["category", "transactionType", "subGroup", "group"];
  const errors = {};

  fieldsToValidate.forEach((field) => {
    const value = obj[field];
    if (value === null || value === undefined || value === "") {
      errors[field] = `${field} cannot be empty or null`;
    }
  });

  return errors;
};
